// extracted by mini-css-extract-plugin
export default {"alert":"PaymentAlert_alert__ESG5r","description":"PaymentAlert_description__ypeCT"};